import { createFileRoute } from "@tanstack/react-router";
import { getAiChat } from "api-client";

import { AIChatThreadPage } from "src/components/AIChatThreadPage";
import { loaderHandler } from "src/lib/loaderHandler";

export const Route = createFileRoute("/_auth/_coach/ai/$chatId")({
  component: RouteComponent,
  ssr: true,
  loader: async (routeContext) => {
    return loaderHandler(async () => {
      const chat = await getAiChat({
        path: {
          chatId: routeContext.params.chatId,
        },
      }).then((response) => {
        return response.data.data;
      });

      return {
        data: {
          chat: chat,
        },
      };
    });
  },
});

function RouteComponent() {
  const loaderData = Route.useLoaderData();

  return <AIChatThreadPage initialChat={loaderData.data.chat} />;
}
